import { render } from "./RecipeSuggestions.vue?vue&type=template&id=06102117"
import script from "./RecipeSuggestions.vue?vue&type=script&lang=js"
export * from "./RecipeSuggestions.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__